module.exports = __webpack_public_path__ + "static/media/product-hunt.0b61d62e.svg";